export const authorData = [
  {
    name: "Erica Armstrong Dunbar",
    books: ["She Came to Slay: The Life and Times of Harriet Tubman"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "ericaarmstrongdunbar.com",
    awards: ["Frederick Douglass Prize"]
  },
  {
    name: "Kalynn Bayron",
    books: ["Cinderella Is Dead", "This Poison Heart", "This Wicked Fate"],
    poc: true,
    gender: "female",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "kalynnbayron.com",
    awards: ["2022 Randall Kenan Prize"]
  },
  {
    name: "Alexis Henderson",
    books: ["The Year of the Witching"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "alexishenderson.com",
    awards: []
  },
  {
    name: "Tiffany D. Jackson",
    books: [
      "Monday's Not Coming",
      "Allegedly",
      "Blackout",
      "Grown",
      "Let Me Hear a Rhyme",
      "Whiteout",
      "The Weight of Blood",
      "White Smoke"
    ],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "writeinbk.com",
    awards: ["NAACP Image Award", "John Steptoe New Talent Award"]
  },
  {
    name: "Kimberly Jones",
    books: ["I'm Not Dying with You Tonight"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "kimjoneswrites.com",
    awards: []
  },
  {
    name: "Gilly Segal",
    books: ["I'm Not Dying with You Tonight"],
    poc: false,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "gillysegal.com",
    awards: []
  },
  {
    name: "Camryn Garrett",
    books: ["Full Disclosure"],
    poc: true,
    gender: "female",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "camryngarrett.com",
    awards: []
  },
  {
    name: "Hallie Rubenhold",
    books: [
      "The Five: The Untold Lives of the Women Killed by Jack the Ripper"
    ],
    poc: false,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "GB",
        name: "United Kingdom"
      }
    ],
    website: "hallierubenhold.com",
    awards: ["Baillie Gifford Prize"]
  },
  {
    name: "Silvia Moreno-Garcia",
    books: ["Gods of Jade and Shadow"],
    poc: false,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "MX",
        name: "Mexico"
      },
      {
        code: "CA",
        name: "Canada"
      }
    ],
    website: "silviamoreno-garcia.com",
    awards: [
      "World Fantasy Award",
      "Copper Cylinder Adult Award",
      "Ignyte Awards",
      "Sunburst Award",
      "Aurora Award",
      "British Fantasy Award—Horror Novel",
      "Locus Award for Best Horror Novel"
    ]
  },
  {
    name: "Cho Nam-Joo",
    books: ["Kim Jiyoung, Born 1982", "Miss Kim Knows and Other Stories"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "KR",
        name: "Korea"
      }
    ],
    website: "",
    awards: []
  },
  {
    name: "Kim Liggett",
    books: ["The Grace Year"],
    poc: false,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "kimliggett.com",
    awards: ["Bram Stoker Award"]
  },
  {
    name: "P. Djèlí Clark",
    books: [
      "Ring Shout",
      "A Master of Djinn",
      "The Black God's Drums",
      "A Dead Djinn in Cairo",
      "Out There Screaming: An Anthology of New Black Horror"
    ],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "TT",
        name: "Trinidad and Tobago"
      },
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "pdjeliclark.com",
    awards: [
      "Compton Crook Award",
      "Ignyte Award",
      "Locus Award",
      "Nebula Award",
      "British Fantasy Award",
      "Locus Award",
      "Nebula Award",
      "Locus Award",
      "Nebula Award"
    ]
  },
  {
    name: "Alexis Hall",
    books: ["Boyfriend Material"],
    poc: false,
    gender: "male",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "GB",
        name: "United Kingdom"
      }
    ],
    website: "quicunquevult.com",
    image: false,
    awards: []
  },
  {
    name: "Brit Bennett",
    books: ["The Vanishing Half"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "britbennett.com",
    awards: ["Goodreads Choice Award"]
  },
  {
    name: "Jordan Ifueko",
    books: ["Raybearer", "Redemptor"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "NG",
        name: "Nigeria"
      },
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "jordanifueko.com",
    awards: []
  },
  {
    name: "Kiley Reid",
    books: ["Such a Fun Age"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "kileyreid.com",
    awards: ["Goodreads Choice Awards", "Australian Book Industry Awards"]
  },
  {
    name: "Dhonielle Clayton",
    books: ["Blackout", "Whiteout"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "dhonielleclayton.com",
    awards: ["Ignyte Award"]
  },
  {
    name: "Nic Stone",
    books: ["Blackout", "Whiteout"],
    poc: true,
    gender: "female",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "nicstone.info",
    awards: ["William C. Morris YA Debut Award", "Kids’ Book Choice Awards"]
  },
  {
    name: "Angie Thomas",
    books: ["Blackout", "Whiteout"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "angiethomas.com",
    awards: [
      "Goodreads Choice Awards",
      "Goodreads Choice Award",
      "Amelia Elizabeth Walden Award",
      "Audie Award",
      "Audie Award",
      "Edgar Award",
      "Goodreads Choice Award",
      "Indies Choice Award",
      "William C. Morris Award",
      "Odyssey Award",
      "Waterstones Children's Book Prize"
    ]
  },
  {
    name: "Ashley Woodfolk",
    books: ["Blackout", "Whiteout"],
    poc: true,
    gender: "female",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "ashleywoodfolk.com",
    awards: []
  },
  {
    name: "Nicola Yoon",
    books: ["Blackout", "Whiteout"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "JM",
        name: "Jamaica"
      },
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "nicolayoon.com",
    awards: []
  },
  {
    name: "Nina Varela",
    books: ["Crier's War", "Iron Heart"],
    poc: false,
    gender: "female",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "ninavarela.com",
    awards: []
  },
  {
    name: "Justina Ireland",
    books: ["Dread Nation", "Deathless Divide", "Rust in the Root"],
    poc: true,
    gender: "female",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "authorjustinaireland.com",
    awards: []
  },
  {
    name: "Faridah Àbíké-Íyímídé",
    books: ["Ace of Spades"],
    poc: true,
    gender: "female",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "GB",
        name: "United Kingdom"
      },
      {
        code: "NG",
        name: "Nigeria"
      }
    ],
    website: "faridahabikeiyimide.com",
    awards: []
  },
  {
    name: "N.K. Jemisin",
    books: [
      "How Long 'til Black Future Month?",
      "The City We Became",
      "The Killing Moon",
      "The World We Make",
      "The Hundred Thousand Kingdoms",
      "Emergency Skin",
      "The Broken Kingdoms",
      "The Kingdom of Gods",
      "The Awakened Kingdom",
      "Shades in Shadow",
      "The Shadowed Sun",
      "The Fifth Season",
      "The Obelisk Gate",
      "The Stone Sky",
      "Out There Screaming: An Anthology of New Black Horror"
    ],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "nkjemisin.com",
    awards: [
      "Sense of Gender Award",
      "Romantic Times Reviewers' Choice Award",
      "Romantic Times Reviewers' Choice Award",
      "BSFA Award for Best Novel",
      "Locus",
      "Locus",
      "Locus",
      "Nebula",
      "Hugo",
      "Hugo",
      "Hugo",
      "Locus",
      "Hugo",
      "American Library Association's Alex Award"
    ]
  },
  {
    name: "Octavia E. Butler",
    books: [
      "Bloodchild and Other Stories",
      "Kindred",
      "Parable of the Sower",
      "Dawn",
      "Adulthood Rites",
      "Imago",
      "Wild Seed",
      "Mind of My Mind",
      "Clay's Ark",
      "Patternmaster"
    ],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "octaviabutler.com",
    awards: [
      "Creative Arts Award",
      "Hugo Award for Best Short Story",
      "Nebula Award for Best Novelette",
      "Locus Award for Best Novelette",
      "Hugo Award for Best Novelette",
      "Science Fiction Chronicle Award for Best Novelette",
      "Science Fiction Chronicle Award for Best Novelette",
      "James Tiptree Jr. Award",
      "Nebula Award for Best Novel",
      "Lifetime Achievement Award in Writing",
      "Solstice Award"
    ]
  },
  {
    name: "Xiran Jay Zhao",
    books: ["Iron Widow"],
    poc: true,
    gender: "non-binary",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "CN",
        name: "China"
      },
      {
        code: "CA",
        name: "Canada"
      }
    ],
    website: "xiranjayzhao.com",
    awards: ["BSFA Award", "Astounding Award"]
  },
  {
    name: "Nnedi Okorafor",
    books: [
      "Binti",
      "Binti: Home",
      "Binti: Night Masquerade",
      "Akata Witch",
      "Out There Screaming: An Anthology of New Black Horror"
    ],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "NG",
        name: "Nigeria"
      },
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "nnedi.com",
    awards: [
      "Hugo Award",
      "Nebula",
      "World Fantasy Award—Novel",
      "Hugo",
      "LaGuardia Wole Soyinka Prize",
      "Zahrah the Windseeker Macmillan Writers Prize for Africa",
      "Long Juju Man Carl Brandon Parallax Award"
    ]
  },
  {
    name: "R.F. Kuang",
    books: [
      "The Poppy War",
      "The Dragon Republic",
      "The Burning God",
      "Babel",
      "Yellowface",
      "Katabasis"
    ],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "CN",
        name: "China"
      },
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "rfkuang.com",
    awards: [
      "Crawford Award",
      "Compton Crook Award",
      "Nebula Award",
      "Locus Award",
      "British Book Award"
    ]
  },
  {
    name: "Namina Forna",
    books: ["The Gilded Ones"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "SL",
        name: "Sierra Leone"
      },
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "naminaforna.com",
    awards: []
  },
  {
    name: "Rivers Solomon",
    books: ["An Unkindness of Ghosts", "The Deep"],
    poc: true,
    gender: "non-binary",
    lgbt: true,
    fav: true,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "rivers-solomon.com",
    awards: []
  },
  {
    name: "Trevor Noah",
    books: ["Born a Crime"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "ZA",
        name: "South Africa"
      }
    ],
    website: "trevornoah.com",
    awards: []
  },
  {
    name: "Talia Hibbert",
    books: ["Get a Life, Chloe Brown"],
    poc: true,
    gender: "female",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "GB",
        name: "United Kingdom"
      }
    ],
    website: "taliahibbert.com",
    awards: []
  },
  {
    name: "June Hur",
    books: ["The Red Palace"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "KR",
        name: "Korea"
      },
      {
        code: "CA",
        name: "Canada"
      }
    ],
    website: "junehur.com",
    awards: []
  },
  {
    name: "Colson Whitehead",
    books: ["The Underground Railroad", "The Nickel Boys"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "colsonwhitehead.com",
    awards: []
  },
  {
    name: "Fonda Lee",
    books: ["Jade City"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      },
      {
        code: "CA",
        name: "Canada"
      },
      {
        code: "CN",
        name: "China"
      }
    ],
    website: "fondalee.com",
    awards: []
  },
  {
    name: "Axie Oh",
    books: ["The Girl Who Fell Beneath the Sea"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      },
      {
        code: "KR",
        name: "Korea"
      }
    ],
    website: "axieoh.com",
    awards: []
  },
  {
    name: "Sidik Fofana",
    books: ["Stories from the Tenants Downstairs"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "sidikfofana.com",
    awards: []
  },
  {
    name: "Krystal Marquis",
    books: ["The Davenports"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "krystalmarquis.com",
    awards: []
  },
  {
    name: "Akwaeke Emezi",
    books: ["Bitter", "The Death of Vivek Oji"],
    poc: true,
    gender: "non-binary", // change to array later
    lgbt: true,
    fav: false,
    country: [
      {
        code: "NG",
        name: "Nigeria"
      }
    ],
    website: "akwaeke.com",
    awards: []
  },
  {
    name: "Tommy Orange",
    books: ["There, There", "Wandering Stars"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "penguinrandomhouse.com/authors/2156371/tommy-orange/",
    awards: []
  },
  {
    name: "B.B. Alston",
    books: ["Amari and the Night Brothers"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "bbalston.com",
    awards: []
  },
  {
    name: "Meredith Katz",
    books: ["The Cybernetic Tea Shop"],
    poc: false,
    gender: "non-binary",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "CA",
        name: "Canada"
      }
    ],
    website: "softcryptid.com",
    awards: []
  },
  {
    name: "Ken Liu",
    books: ["The Hidden Girl and Other Stories"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      },
      {
        code: "CN",
        name: "China"
      }
    ],
    website: "kenliu.name",
    awards: []
  },
  {
    name: "Nella Larsen",
    books: ["Passing"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "en.wikipedia.org/wiki/Nella_Larsen",
    awards: []
  },
  {
    name: "Kanae Minato",
    books: ["Confessions", "Penance"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "JP",
        name: "Japan"
      }
    ],
    website: "en.wikipedia.org/wiki/Kanae_Minato",
    awards: []
  },
  {
    name: "Ling Ling Huang",
    books: ["Natural Beauty"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      },
      {
        code: "CN",
        name: "China"
      }
    ],
    website: "www.linglinghuang.com",
    awards: []
  },
  {
    name: "Honorée Fanonne Jeffers",
    books: ["The Love Songs of W.E.B. Du Bois"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "honoreejeffers.com",
    awards: []
  },
  {
    name: "Tracey Rose Peyton",
    books: ["Night Wherever We Go"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "traceyrosepeyton.com",
    awards: []
  },
  {
    name: "Erin E. Adams",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      },
      {
        code: "HT",
        name: "Haiti"
      }
    ],
    website: "erineadams.com",
    awards: []
  },
  {
    name: "Violet Allen",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "",
    awards: []
  },
  {
    name: "Lesley Nneka Arimah",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "NG",
        name: "Nigeria"
      },
      {
        code: "GB",
        name: "United Kingdom"
      }
    ],
    website: "larimah.com",
    awards: []
  },
  {
    name: "Maurice Broaddus",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "mauricebroaddus.com",
    awards: []
  },
  {
    name: "Chesya Burke",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "thechesyaburke.org",
    awards: []
  },
  {
    name: "Ezra Claytan Daniels",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "ezracdaniels.com",
    awards: []
  },
  {
    name: "Tananarive Due",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "tananarivedue.com",
    awards: []
  },
  {
    name: "Nalo Hopkinson",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "female",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "JM",
        name: "Jamaica"
      },
      {
        code: "CA",
        name: "Canada"
      }
    ],
    website: "nalohopkinson.com",
    awards: []
  },
  {
    name: "Justin C. Key",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "",
    awards: []
  },
  {
    name: "L.D. Lewis",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "female",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "ldlewiswrites.com",
    awards: []
  },
  {
    name: "Tochi Onyebuchi",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "tochionyebuchi.com",
    awards: []
  },
  {
    name: "Rebecca Roanhorse",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "rebeccaroanhorse.com",
    awards: []
  },
  {
    name: "Nicole D. Sconiers",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "",
    awards: []
  },
  {
    name: "Rion Amilcar Scott",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "rionamilcarscott.com",
    awards: []
  },
  {
    name: "Terence Taylor",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "",
    awards: []
  },
  {
    name: "Cadwell Turnbull",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "cadwellturnbull.com",
    awards: []
  },
  {
    name: "Isabel Wilkerson",
    books: ["Caste: The Origins of Our Discontents"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "isabelwilkerson.com",
    awards: []
  },
  {
    name: "Megan Giddings",
    books: ["Lakewood"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "megangiddings.com",
    awards: []
  },
  {
    name: "Sohn Won-Pyung",
    books: ["Almond"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "KR",
        name: "Korea"
      }
    ],
    website: "en.wikipedia.org/wiki/Sohn_Won-pyung",
    awards: []
  },
  {
    name: "Jamila Rowser",
    books: ["Wash Day Diaries"],
    poc: true,
    gender: "female",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "PR",
        name: "Puerto Rico"
      },
      {
        code: "DO",
        name: "Dominican Republic"
      },
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "jamilarowser.com",
    awards: []
  },
  {
    name: "Robyn Smith",
    books: ["Wash Day Diaries"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "JM",
        name: "Jamaica"
      }
    ],
    website: "robrosmo.com",
    awards: []
  },
  {
    name: "Emma Newman",
    books: [
      "Planetfall",
      "After Atlas",
      "Before Mars",
      "Atlas Alone",
      "Before, After, Alone"
    ],
    poc: false,
    gender: "female",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "GB",
        name: "United Kingdom"
      }
    ],
    website: "enewman.co.uk",
    awards: []
  },
  {
    name: "Martha Wells",
    books: [
      "All Systems Red",
      "Artificial Condition",
      "Rogue Protocol",
      "Exit Strategy",
      "Network Effect",
      "Fugitive Telemetry",
      "System Collapse"
    ],
    poc: false,
    gender: "female",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "marthawells.com",
    awards: []
  },
  {
    name: "Dolen Perkins-Valdez",
    books: ["Take My Hand"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "dolenperkinsvaldez.com",
    awards: []
  },
  {
    name: "Nana Kwame Adjei-Brenyah",
    books: ["Chain-Gang All-Stars"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      },
      {
        code: "GH",
        name: "Ghana"
      }
    ],
    website: "nanakwameadjei-brenyah.com",
    awards: []
  },
  {
    name: "James Islington",
    books: ["The Will of the Many"],
    poc: false,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "AU",
        name: "Australia"
      }
    ],
    website: "jamesislington.com",
    awards: []
  },
  {
    name: "Julia Alvarez",
    books: ["In the Time of the Butterflies"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "DO",
        name: "Dominican Republic"
      },
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "juliaalvarez.com",
    awards: []
  },
  {
    name: "Philippa Gregory",
    books: [
      "The Lady of the Rivers",
      "The White Queen",
      "The Red Queen",
      "The Kingmakers Daughter",
      "The White Princess",
      "The King's Curse",
      "The Other Boleyn Girl",
      "The Boleyn Inheritance",
      "The Taming of the Queen",
      "The Queen's Fool",
      "The Last Tudor",
      "The Virgin’s Lover",
      "The Other Queen",
      "Boleyn Traitor"
    ],
    poc: false,
    gender: "female",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "GB",
        name: "United Kingdom"
      }
    ],
    website: "philippagregory.com",
    awards: []
  },
  {
    name: "Alice Oseman",
    books: ["Heartstopper: Volume One"],
    poc: false,
    gender: "female",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "GB",
        name: "United Kingdom"
      }
    ],
    website: "aliceoseman.com",
    awards: []
  },
  {
    name: "Jonathan Larson",
    books: ["Tick, Tick... Boom!"],
    poc: false,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "en.wikipedia.org/wiki/Jonathan_Larson",
    awards: []
  },
  {
    name: "Pamela Nagami M.D.",
    books: [
      "The Woman with a Worm in Her Head: And Other True Stories of Infectious Disease"
    ],
    poc: false,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "bjrobbinsliterary.com/pamela-nagami-md",
    awards: []
  },
  {
    name: "Sierra Greer",
    books: ["Annie Bot"],
    poc: false,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "sierragreerwriter.com",
    awards: []
  }
];
